import services from 'services/module';
import {CookieSettings} from 'services/CookieSettings';
import {HttpSvcFactory} from './HttpSvc';
import {AuthenticationSvc} from './AuthenticationSvc';

type langs = 'en' | 'ru' | 'es' | 'ko';
type map = {[s: string]: string};
export class TranslateSvc {
    static cookieName = '_animatron_lang';
    static defaultLang: 'en' = 'en';
    static productionLangs: Array<langs> = ['en', 'es', 'ko', 'ru'];

    lang: langs;
    map: map = {};
    initialized = false;

    domainToLang = {
        kr: 'ko'
    };

    supportedLangs = _.object(_.pairs({
        en: 'English',
        es: 'Español',
        ru: 'Русский',
        ko: '한국어'
    }).filter(l => !options.isProduction || TranslateSvc.productionLangs.includes(l[0])));

    constructor(private $http: ng.IHttpService,
                private $log: ng.ILogService,
                private $ocLazyLoad: oc.ILazyLoad,
                private $q: ng.IQService,
                private ipCookie: any,
                private AuthenticationSvc: AuthenticationSvc,
                private HttpSvc: HttpSvcFactory) {
    }

    has(key: string) {
        return !!this.map[key];
    }

    public get(key?: string, ...params: Array<string>): string { //TODO make return type optional
        const k = (_.isString(key) && key.replace(/\s+/g, '.')) || null;
        if (k && this.initialized && !this.map[k]) {
            if (options.isLocal) {
                this.$log.error(`missing translation for '${k}'`);
                _.notification.showError(`missing translation for '${k}'`);
            }
            return k;
        }
        if (key && !_.isString(key)) this.$log.error(`wrong key used for translation: '${key}'`);
        return this.map[k] ? params.reduce((str, param) => str.replace(/{\d}/, param), this.map[k]) : undefined;
    };

    public async = (key: string) => this.fetchTranslations().then(() => this.get(key));

    public langChange(lang: langs) {
        if (!(lang in this.supportedLangs)) throw new Error(`how come? ${lang}`);
        if (lang === this.lang) return;
        this.ipCookie(TranslateSvc.cookieName, lang, CookieSettings.get());
        new Promise(() => document.body.style.cursor = 'progress');
        if (!options.user.anonymous) {
            const newProps = {meta: {lang}};
            this.AuthenticationSvc.extendUser(newProps);
            this.HttpSvc('profile').securePut(newProps).then(() => location.reload());
        } else {
            location.reload();
        }
    };

    public currentLang(): langs {
        const langProps = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
        try {
            const foundLang = (options.user.meta && options.user.meta.lang) ||
                this.ipCookie(TranslateSvc.cookieName) ||
                this.langFromTLD() ||
                navigator[_.find(langProps, l => l in navigator)] .split('_')[0].split('-')[0].toLowerCase();
            return foundLang in this.supportedLangs ? foundLang : TranslateSvc.defaultLang;
        } catch (e) {
            this.$log.error(e);
            return TranslateSvc.defaultLang;
        }
    };

    public fetchTranslations = _.once(() => this.$q<map>(resolve => {
        const current = this.currentLang();
        this.changeLocale(current);
        const url = require(`../../i18n/m_${current}.properties`);
        return this.$http.get<map>(url).then(r => this.set(r.data, current, resolve));
    }));

    private set(map: map, current: langs, resolve: ng.IQResolveReject<map>) {
        this.lang = current;
        this.map = map;
        Object.freeze(this.map);
        this.initialized = true;
        this.ipCookie(TranslateSvc.cookieName, this.lang, CookieSettings.get());
        document.documentElement.lang = this.lang;
        Object.freeze(this);
        resolve(this.map);
    }

    private changeLocale(lang: langs) {
        if (lang === 'en') return;
        this.$ocLazyLoad.load({
            name: 'ngLocale',
            files: [`https://cdnjs.cloudflare.com/ajax/libs/angular-i18n/1.6.2/angular-locale_${lang}.min.js`]
        }).then(() => {
            try {
                angular.merge(
                    angular.element(document).injector().get('$locale'),
                    angular.injector(['ngLocale']).get('$locale')
                );
            } catch (e) {
                console.error('error chaning $locale', e);
            }
        });
    }

    private langFromTLD() {
        return this.domainToLang[location.hostname.split('.').pop()];
    }
}
services
    .service('TranslateSvc', TranslateSvc)
    .directive('tHtml', ($sce: ng.ISCEService, TranslateSvc: TranslateSvc) => ({
        scope: false,
        restrict: 'A',
        link(scope: any, element: ng.IAugmentedJQuery, attrs: {tHtml: string}) {
            element.html($sce.trustAs('html', TranslateSvc.get(attrs.tHtml)));
        }
    }));



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/TranslateSvc.ts